import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayTypeOPEEnum} from "./GatewayTypeOPEEnum";

class O {
  id!: number;
}

/**
 * O Inner Class
 */
class I {
  id?: number;
  modelName!: string;
  partNumber?: string;
  osType!: string;
  additionalInfo!: GatewayTypeAdditionalInfoDTO;
}

class GatewayTypeAdditionalInfoDTO {
  rtuPorts?: string[];
}

export class PutGatewayTypeCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayTypeOPEEnum.PutGatewayType);
    this.i = new I();
    this.o = new O();
  }
}
